import { useContext, useEffect } from 'react';
import { SEOContext } from '@/lib/SEOContext';

export default function SEOMeta({ title, description, canonical, noindex = false }) {
  const collector = useContext(SEOContext);
  if (collector) Object.assign(collector, { title, description, canonical: canonical?.replace(/^https:\/\/www\./i, 'https://').replace(/\/$/, '') || 'https://oliverandsons.com.au/', noindex });
  useEffect(() => {
    const normalizedCanonical = canonical ? canonical.replace(/^https:\/\/www\./i, 'https://') : canonical;

    // Title
    document.title = title;

    // Lang
    document.documentElement.lang = 'en-AU';

    const setMeta = (selector, attr, value) => {
      let el = document.querySelector(selector);
      if (!el) {
        el = document.createElement('meta');
        const [attrName, attrVal] = attr.split('=');
        el.setAttribute(attrName, attrVal.replace(/"/g, ''));
        document.head.appendChild(el);
      }
      el.setAttribute('content', value);
    };

    const setLink = (rel, href) => {
      let el = document.querySelector(`link[rel="${rel}"]`);
      if (!el) {
        el = document.createElement('link');
        el.setAttribute('rel', rel);
        document.head.appendChild(el);
      }
      el.setAttribute('href', href);
    };

    // Standard meta
    setMeta('meta[name="description"]', 'name=description', description);
    if (noindex) setMeta('meta[name="robots"]', 'name=robots', 'noindex, follow');
    else document.querySelector('meta[name="robots"]')?.remove();

    // Canonical
    if (normalizedCanonical) setLink('canonical', normalizedCanonical);

    // Open Graph
    setMeta('meta[property="og:title"]', 'property=og:title', title);
    setMeta('meta[property="og:description"]', 'property=og:description', description);
    setMeta('meta[property="og:type"]', 'property=og:type', 'website');
    if (normalizedCanonical) setMeta('meta[property="og:url"]', 'property=og:url', normalizedCanonical);
  }, [title, description, canonical, noindex]);

  return null;
}
